import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { CantidadPorTipoDto } from '@models/base/cantidadPorTipoDto.model';
import { MovimientoService } from '@services/movimiento/movimiento.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { Chart, ChartConfiguration, ChartType, registerables } from 'chart.js';

// Registrar Chart.js components
Chart.register(...registerables);

@Component({
  standalone: true,
  imports: [
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatDividerModule,
    MatButtonModule,
    RouterModule,
    MatIconButton,
    MatIconModule,
    NgxSpinnerModule,
    CommonModule,
    AppRolesDirective
  ],
  selector: 'app-dashboard-movimientos',
  templateUrl: './dashboard-movimientos.component.html',
  styleUrls: ['./dashboard-movimientos.component.css']
})
export class DashboardMovimientosComponent implements AfterViewInit, OnDestroy {

  @ViewChild('chartTipo') chartTipo!: ElementRef<HTMLCanvasElement>;

  cardLayout: any
  formBuilder: FormBuilder = new FormBuilder;
  form!: FormGroup;
  cantidadPorTipoDto: CantidadPorTipoDto[] = [];

  private chartTipoInstance: Chart | null = null;

  constructor(
    private movimientoService: MovimientoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initChart();
    }, 1000);
  }

  ngOnInit(): void {
    this.getCantidadPorTipoDto(); // Activar la llamada al servicio
  }

  initChart(): void {
    this.initChartTipo();
  }

  initChartTipo(): void {
    if (!this.chartTipo?.nativeElement || this.cantidadPorTipoDto.length === 0) {
      return;
    }

    const ctx = this.chartTipo.nativeElement.getContext('2d');
    if (!ctx) return;

    if (this.chartTipoInstance) {
      this.chartTipoInstance.destroy();
    }

    this.chartTipoInstance = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.cantidadPorTipoDto.map(item => item.descripcion),
        datasets: [{
          data: this.cantidadPorTipoDto.map(item => item.cantidad),
          backgroundColor: [
            '#6366f1', // Índigo
            '#10b981', // Esmeralda
            '#f59e0b', // Ámbar
            '#ef4444', // Rojo
            '#8b5cf6', // Violeta
            '#06b6d4', // Cian
            '#84cc16', // Lima
            '#f97316', // Naranja
            '#ec4899', // Rosa
            '#64748b'  // Slate
          ],
          borderWidth: 0,
          hoverBorderWidth: 2,
          hoverBorderColor: '#ffffff'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 12,
              font: {
                size: 11,
                family: 'Roboto, sans-serif'
              },
              color: '#5f6368'
            }
          },
          tooltip: {
            backgroundColor: '#202124',
            titleColor: '#ffffff',
            bodyColor: '#ffffff',
            borderColor: '#5f6368',
            borderWidth: 1,
            cornerRadius: 6,
            callbacks: {
              label: (context: any) => {
                const label = context.label || '';
                const value = context.parsed;
                const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
                const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
                return `${label}: ${value} (${percentage}%)`;
              }
            }
          }
        },
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10
          }
        }
      }
    });
  }

  getCantidadPorTipoDto() {
    this.spinner.show("spCantidadPorTipo")
    this.movimientoService.getCantidadPorTipoDto().subscribe(
      data => {
        this.spinner.hide("spCantidadPorTipo")
        this.cantidadPorTipoDto = data
        setTimeout(() => this.initChartTipo(), 300);
      },
      error => {
        this.spinner.hide("spCantidadPorTipo")
        this.snackBar.showError(error, "Error");
      })
  }

  calcularCantidadTotalMovimientoPorTipo(): number {
    return this.cantidadPorTipoDto.reduce((total, item) => total + item.cantidad, 0);
  }

  ngOnDestroy(): void {
    if (this.chartTipoInstance) {
      this.chartTipoInstance.destroy();
    }
  }
}
